import { createSlice } from "@reduxjs/toolkit";

const startingState = {
    items: [],
}

const ProductsSlice = createSlice({
    name: "products",
    initialState: startingState,
    reducers:{
        addtocart : (state,action) => {
          const finditem = state.items.find(item=> item.id === action.payload.id)
            if(finditem){
                finditem.quantity += 1
            }else{
                state.items.push({...action.payload,quantity: 1})
            }

        },
        removefromcart: (state,action) => {
            state.items = state.items.filter(d=> d.id !== action.payload.id)
        },
        increaseqty: (state,action) => {
            const finditem = state.items.find(item=> item.id === action.payload.id)
            if(finditem){
                finditem.quantity += 1
            }
        },
        decreaseqty: (state,action) => {
            const finditem = state.items.find(item=> item.id === action.payload.id)
            if(finditem){
                if(finditem.quantity > 1){
                finditem.quantity -= 1
                }else{
                    state.items = state.items.filter(d=> d.id !== action.payload.id)
                }
            }
        }
    }
})


export default ProductsSlice.reducer

export const { addtocart,removefromcart,increaseqty,decreaseqty } = ProductsSlice.actions;
